import React from 'react';
import { Dialog, IconButton } from '@mui/material';
import WarningRoundedIcon from '@mui/icons-material/WarningRounded';
import InfoRoundedIcon from '@mui/icons-material/InfoRounded';
import CloseIcon from '@mui/icons-material/Close';
import styles from './styles.module.css';

function ConfirmationDialog({ 
  open, 
  handleClose, 
  handleConfirm, 
  title, 
  message, 
  confirmText = 'Yes', 
  cancelText = 'Cancel', 
  loading = false,
  type = 'warning' 
}) {
  const isWarning = type === 'warning';

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth="sm"
      PaperProps={{
        className: styles.contentWrapperXs,
        style: { padding: 0, overflow: 'hidden' }
      }}
    >
      <div className={styles.popupHeader} style={{ padding: '20px 24px 0 24px', border: 'none', background: 'none' }}>
        <div className={styles.popupHeaderContent}>
          <div className={`${styles.popupIcon} ${isWarning ? styles.popupIconExpired : ''}`} style={{ backgroundColor: isWarning ? '#fee2e2' : '#e0f2fe', color: isWarning ? '#dc2626' : '#0284c7' }}>
            {isWarning ? <WarningRoundedIcon /> : <InfoRoundedIcon />}
          </div>
          <div>
            <h2 className={styles.popupTitle} style={{ margin: 0 }}>{title}</h2>
          </div>
        </div>
        <IconButton 
          onClick={handleClose} 
          style={{ position: 'absolute', right: 8, top: 8, color: '#9ca3af' }}
          disabled={loading}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </div>

      <div className={styles.popupContent} style={{ padding: '12px 24px 24px 24px' }}>
        <div className={styles.popupMessage}>
          <p style={{ margin: 0, lineHeight: '1.5', color: '#4b5563' }}>{message}</p>
        </div>

        <div className={styles.popupActions} style={{ marginTop: 8 }}>
          <button
            className={styles.popupRenew}
            style={{ 
              backgroundColor: isWarning ? '#dc2626' : '#2563eb',
              opacity: loading ? 0.7 : 1
            }}
            onClick={handleConfirm}
            disabled={loading}
          >
            {loading ? 'Processing...' : confirmText}
          </button>
          <button 
            className={styles.popupLater} 
            onClick={handleClose} 
            disabled={loading}
          >
            {cancelText}
          </button>
        </div>
      </div>
    </Dialog>
  );
}

export default ConfirmationDialog;
